$('#bForm').on('submit', function (e) {
    e.preventDefault();

    let businessFirstName   = $('#bFormFirstName').val(),
        businessLastName    = $('#bFormLastName').val(),
        bFormOrganisation        = $('#bFormOrganisation').val(),
        businessEmail       = $('#bFormEmail').val();

    const IS_VALID_EMAIL = $('[type=email]')[0].checkValidity();

    if (IS_VALID_EMAIL) {
        $.ajax({
            url: $('#ajax_url').val(),
            type: "POST",
            cache: false,
            data: {
                action: 'business_send_email',
                name: businessFirstName,
                nameLast: businessLastName,
                organisation: bFormOrganisation,
                email: businessEmail
            },
            success: function (res) {
                successBusinessSend(res);
            }
        });
    }
});
